<template>
  <div class="modal__content">
    <div
      class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200 dark:border-dark-5"
    >
      <h2 class="font-medium text-base mr-auto">
        Add Question
      </h2>
    </div>
    <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
      <div class="col-span-12">
        <label>Question</label>
        <markdown-editor
          type="text"
          placeholder="Type your question"
          v-model="model.question_description"
        ></markdown-editor>
        <!-- <input
          v-model="model.question_description"
          type="text"
          class="input w-full border mt-2 flex-1"
          placeholder="Type your question"
        /> -->
      </div>
      <div class="col-span-12">
        <label>Score</label>
        <!-- <markdown-editor v-model="value"></markdown-editor> -->
        <input
          v-model="model.score"
          type="number"
          class="input w-full border mt-2 flex-1"
          placeholder="Score per correct answer"
        />
      </div>
      <div class="col-span-12">
        <label>Question Type</label>
        <TailSelect
          v-model="model.question_type"
          @input="changedType"
          :options="{
            hideSelected: true,
            hideDisabled: true,
            multiShowCount: false,
            multiContainer: true,
            classNames: 'w-full',
          }"
          single
        >
          <option value="MCQ">MCQ</option>
          <option value="textbox">Text Box</option>
          <option value="textarea">Text Area</option>
          <option value="file">File</option>
        </TailSelect>
      </div>
      <div class="col-span-12" v-if="model.question_type == 'MCQ'">
        <label>Options</label>
        <div v-if="model.options.length > 0">
          <div
            v-for="(o, i) in model.options"
            :key="i"
            class="grid grid-cols-3"
          >
            <div v-if="findImage(o) != ''" class="col-span-3">
              <img :src="findImage(o)" />
            </div>
            <div class="col-span-2">
              <input
                :ref="`option${i}`"
                v-model="model.options[i]"
                @keypress.enter="atOptionEnter(i)"
                type="text"
                class="input w-full border mt-2 flex-1"
                placeholder="Option"
              />
            </div>
            <div class="col-span-1 my-auto font-bold">
              <input
                v-model="correctAnswer[o]"
                type="checkbox"
                class="m-5"
                @change="changedAns(o)"
              />
              <button
                class="button px-2 mr-1 mb-2 bg-theme-6 text-white"
                @click="model.options.splice(i, 1)"
              >
                <span class="w-5 h-5 flex items-center justify-center">
                  <TrashIcon class="w-4 h-4" />
                </span>
              </button>
              <button class="button px-2 mr-1 mb-2 bg-theme-1 text-white">
                <Uploader
                  :label="o + 'File'"
                  @uploaded="(evt) => uploadedFile(evt, o)"
                >
                  <span class="w-5 h-5 flex items-center justify-center">
                    <ImageIcon class="w-4 h-4" />
                  </span>
                </Uploader>
              </button>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <button
            type="button"
            class="button w-24 bg-theme-1 text-white mt-5"
            @click="model.options.push('')"
          >
            Add option
          </button>
        </div>
      </div>
    </div>
    <div
      class="px-5 py-3 text-right border-t border-gray-200 dark:border-dark-5"
    >
      <!--      <button-->
      <!--          type="button"-->
      <!--          data-dismiss="modal"-->
      <!--          class="button w-20 border text-gray-700 dark:border-dark-5 dark:text-gray-300 mr-1"-->
      <!--      >-->
      <!--        Cancel-->
      <!--      </button>-->
      <button
        v-if="!isEditMode"
        type="button"
        class="button w-20 bg-theme-1 text-white"
        @click="addQuestion()"
      >
        Add
      </button>
      <button
        v-else
        type="button"
        class="button w-20 bg-theme-1 text-white"
        @click="updateQues()"
      >
        Update
      </button>
    </div>
  </div>
</template>

<script>
import Uploader from './Uploader'
//import Button from "../../views/Button";
export default {
  name: 'UTableVue',
  components: {
    // Button,
    Uploader,
  },
  props: ['data', 'isEditMode', 'quiz', 'ques'],
  data() {
    return {
      isModal: true,
      headers: ['Question', 'Answer', 'Type', 'Score', 'Actions'],
      correctAnswer: {},
      images: {},
      model: {
        question_subject: '',
        question_description: '',
        question_type: 'MCQ',
        options: [],
        answer_type: 'predefined',
        answer: '',
        score: 1,
        Other: {},
      },
      // isEditMode: false,
      imageChanged: false,
      imageOption: {},
    }
  },
  created() {
    if (this.isEditMode) {
      this.model = { ...this.data }
      this.correctAnswer[this.model.answer] = true
    }
  },
  methods: {
    deleteQuestion(q) {
      this.$upskill.orgDeleteQuesByID(q.question_id).then(() => {
        this.$emit('quesAdded')
      })
    },
    openAddQues() {
      this.images = {}
      this.isEditMode = false
    },
    openEditQues(q) {
      this.images = {}
      this.model = q
      this.images = q.Other['images'] ? q.Other.images : {}
      this.isEditMode = true
    },
    uploadedFile(e, opt) {
      let link =
        'https://upskill-files.s3-ap-southeast-1.amazonaws.com/' + e.link
      // console.log(link);
      // console.log(typeof opt, opt);
      let img = {
        [opt]: link,
      }
      this.images = { ...this.images, ...img }
      // if (!this.model.Other["images"]) {
      //   this.model.Other.images = {};
      // }
      // this.model.Other.images[o] = {
      //   imageURL: link,
      //   label: "",
      //   view_mode: "full"
      // };
      // this.images[String(o)] = {
      //   imageURL: link,
      //   label: "",
      //   view_mode: "full"
      // };
      this.imageChanged = !this.imageChanged
    },
    findImage(o) {
      // if (!Object.keys(this.model.Other).includes("images")) {
      //   return "";
      // }
      // if (!Object.keys(this.model.Other.images).includes(o)) {
      //   return "";
      // }
      // return this.model.Other.images[o].imageURL;
      if (!this.images[o]) {
        return ''
      }
      return this.images[o]
    },
    atOptionEnter(currentIndex) {
      this.model.options.push('')
      console.log(this.$refs)
      this.$nextTick(() => this.$refs[`option${currentIndex + 1}`][0].focus())
    },
    updateQues() {
      this.model.answer = this.selectedAnswer()
      this.model.question_subject = this.quiz.quiz_subject
      this.model.answer_type = 'predefined'
      this.model.question_type = 'MCQ'
      this.model.score = parseInt(this.model.score)
      this.model.other = {} //NEED WORK
      this.model.other.images = this.images //NEED WORK
      this.$upskill.orgUpdateQues(this.model).then(() => {
        this.closeAllModals()
        this.resetModel()
        window.alert('updated!')
        this.$emit('quesAdded')
      })
    },
    resetModel() {
      this.model = {
        question_subject: '',
        question_description: '',
        question_type: 'MCQ',
        options: [],
        answer_type: 'predefined',
        answer: '',
        score: 1,
        Other: {},
      }
    },
    changedType(e) {
      switch (e) {
        case 'MCQ':
          this.model.options = []
          this.model.question_type = 'MCQ'
          this.model.answer = ''
          this.model.answer_type = 'predefined'
          break
        case 'textarea':
          this.model.options = []
          this.model.question_type = 'textarea'
          this.model.answer = ''
          this.model.answer_type = 'manual'
          break
        case 'textbox':
          this.model.options = []
          this.model.question_type = 'textbox'
          this.model.answer = ''
          this.model.answer_type = 'manual'
          break
        case 'file':
          this.model.options = []
          this.model.question_type = 'file'
          this.model.answer = ''
          this.model.answer_type = 'manual'
          break
        default:
          this.model.options = []
          this.model.question_type = 'MCQ'
          this.model.answer = ''
          this.model.answer_type = 'predefined'
      }
    },
    addQuestion() {
      this.isEditMode = false
      this.model.answer = this.selectedAnswer()
      this.model.question_subject = this.quiz.quiz_subject
      // this.model.answer_type = "predefined";
      // this.model.question_type = "MCQ";
      this.model.other = {} //NEED WORK
      this.model.other.images = this.images //NEED WORK
      this.model.score = parseInt(this.model.score)
      this.$upskill.orgAddQues(this.model).then((res) => {
        let ques_id = res.data.data.question_id
        let bindForm = {
          quiz_id: this.quiz.quiz_id,
          question_ids: [ques_id],
        }
        this.$upskill.orgSaveQuesToQuiz(bindForm).then(() => {
          this.model = {
            question_id: '',
            question_subject: '',
            question_description: '',
            question_type: 'MCQ',
            options: [],
            answer_type: 'predefined',
            answer: '',
            score: 1,
            Other: {},
          }
          this.correctAnswer = {}
          this.closeAllModals()
          this.resetModel()
          this.$emit('quesAdded')
        })
      })
    },
    selectedAnswer() {
      for (let k in this.correctAnswer) {
        if (this.correctAnswer[k]) {
          return k
        }
      }
      return ''
    },
    closeAllModals() {
      const modals = document.getElementsByClassName('modal')
      for (let i = 0; i < modals.length; i++) {
        modals[i].classList.remove('show')
      }
    },
    changedAns(o) {
      for (let k in this.correctAnswer) {
        this.correctAnswer[k] = false
      }
      this.correctAnswer[o] = true
    },
  },
}
</script>
<style scoped>
.v-md-wrapper {
  max-height: 250px !important;
}
.mb100 {
  max-height: 26px;
}
</style>
